// Fired after the account's settings are saved; readers of /auth/settings refetch.
export const SETTINGS_CHANGED = 'aveq:settings-changed';
